export default function getSavedState<T>(key: string): T {
  return JSON.parse(window.localStorage.getItem(key) || 'null')
}
